document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-button');
    const images = document.querySelectorAll('.tab-image');

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
        // Remove active state
        tabs.forEach((t) => t.classList.remove('active'));
        images.forEach((img) => img.classList.remove('active'));

        // Add active state to selected
        tab.classList.add('active');
        const target = document.getElementById(tab.getAttribute('data-tab'));
        if (target) target.classList.add('active');
        });
    });

    const tabsSpace = document.querySelectorAll(".tab-button-space");
    const panels = document.querySelectorAll(".tab-panel");

    // Tab switching logic
    tabsSpace.forEach(tab => {
        tab.addEventListener("click", () => {
        const targetId = tab.getAttribute("data-tab");

        tabsSpace.forEach(t => t.classList.remove("active"));
        panels.forEach(p => p.classList.remove("active"));

        tab.classList.add("active");
        document.getElementById(targetId).classList.add("active");
        });
    });

    // Smooth horizontal scroll on wheel inside wrapper
    const scrollContainers = document.querySelectorAll(".products-scroll");

    scrollContainers.forEach(container => {
        container.addEventListener("wheel", (e) => {
        if (e.deltaY === 0) return; // Ignore horizontal wheel
        e.preventDefault(); // Prevent page scroll
        container.scrollBy({
            left: e.deltaY * 1.2, // Adjust scroll speed
            behavior: "smooth"
        });
        });
    });

    const scrollEnhanceContainers = document.querySelectorAll(".enhance-vision-scroll");

    scrollEnhanceContainers.forEach(container => {
        container.addEventListener("wheel", (e) => {
        if (e.deltaY === 0) return;
        e.preventDefault();
        container.scrollBy({
            left: e.deltaY * 1.2,
            behavior: "smooth"
        });
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
  const swiperEl = document.querySelector(".build-package-swiper");
  if (!swiperEl) return;

  new Swiper(swiperEl, {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: false, // Prevent infinite width bug
    grabCursor: true,
    navigation: {
      nextEl: ".build-next",
      prevEl: ".build-prev",
    },
    breakpoints: {
      768: { slidesPerView: 1, spaceBetween: 16 },
      1200: { slidesPerView: 2, spaceBetween: 20 }
    }
  });
});

// Reinitialize in Shopify Theme Editor

document.addEventListener("shopify:section:load", function(event) {
  const swiperEl = event.target.querySelector(".build-package-swiper");
  if (!swiperEl) return;

  new Swiper(swiperEl, {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: false,
    grabCursor: true,
    navigation: {
      nextEl: ".build-next",
      prevEl: ".build-prev",
    },
    breakpoints: {
      768: { slidesPerView: 1, spaceBetween: 16 },
      1200: { slidesPerView: 2, spaceBetween: 20 }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.review-commercial-swiper', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: false,
    grabCursor: true,
    navigation: { nextEl: '.review-next', prevEl: '.review-prev' },
    breakpoints: {
      340: { slidesPerView: 1, spaceBetween: 12 },
      768: { slidesPerView: 2, spaceBetween: 16 },
      1024: { slidesPerView: 3, spaceBetween: 20 }
      }
  });
});